<template>
<div class="content">
	<div class="menu-bar">
		<div class="container">
			<Menubar></Menubar>
		</div>
	</div>
	<div class="main-banner">
		<div class="container">

			<p class="title " v-html="l10.All_Main_Body_Title1">

			</p>
			<p class="subtitle " v-html="l10.All_Main_Body_Title1_Description1">

			</p>
			<template v-if="isAndroid && this.$store.state.lang == 'cn' && this.$store.state.cnDownloadUrl != ''">
				<div id="tryBtn" @click="handleClickAndroidDownload">
					<span v-html="l10.All_Main_Body_Title1_Button2"></span>
				</div>
			</template>
			<template v-else>
				<a :href="downloadUrl" target="_blank">
					<div id="tryBtn" :class="[isAndroid ? 'mo_playstore_btn' : 'mo_appstore_btn']">
						{{l10.All_Main_Body_Title1_Button1}}
					</div>
				</a>
			</template>
		</div>

	</div>
	<div id="article1" class="article">
		<div class="container">

			<p class="title " v-html="l10.All_Main_Body_Title2">

			</p>
			<p class="subtitle " v-html="l10.All_Main_Body_Title2_Description1">

			</p>
			<div class="articles ">
				<div>
					<img src="../../assets/home/img-main-testimonial-1.svg" />
					<p class="description" v-html="l10.All_Main_Body_Title2_Quote1">
					</p>
					<p class="source" v-html="l10.All_Main_Body_Title2_Source1">
					</p>
				</div>
				<div>
					<img src="../../assets/home/img-main-testimonial-2-m.png" />
					<p class="description" v-html="l10.All_Main_Body_Title2_Quote2">
					</p>
					<p class="source" v-html="l10.All_Main_Body_Title2_Source2">
					</p>
				</div>
				<div>
					<img src="../../assets/home/img-main-testimonial-3.svg" />
					<p class="description" v-html="l10.All_Main_Body_Title2_Quote3">
					</p>
					<p class="source" v-html="l10.All_Main_Body_Title2_Source3">
					</p>
				</div>

			</div>
			<div id="download600Img" class=" ">

			</div>



		</div>
	</div>
	<div id="article2">
		<div class="container">
			<p v-html="l10.All_Main_Body_Title3">

			</p>
			<div class="descriptions">
				<div class="img">
					<img src="../../assets/home/img-main-features-setcion-1-m.png" srcset="../../assets/home/img-main-features-setcion-1-m@2x.png 2x,
             ../../assets/home/img-main-features-setcion-1-m@3x.png 3x" class="img_main_features_setcion1">
				</div>
				<div class="description">
					<p class="title" v-html="l10.All_Main_Body_Title3_Subtitle1">

					</p>
					<div class="text">

						<p v-html="l10.All_Main_Body_Title3_Subtitle1_Description1">

						</p>

						<p v-html="l10.All_Main_Body_Title3_Subtitle1_Description2">

						</p>

						<p v-html="l10.All_Main_Body_Title3_Subtitle1_Description3">

						</p>
					</div>
					<router-link to="/curriculum/guide">
						<div class="button">
							<span v-html="l10.All_Main_Body_Title3_Subtitle1_Button1"></span>

						</div>
					</router-link>
				</div>

			</div>
			<div class="descriptions">
				<div class="img">
					<img src="../../assets/home/img-main-features-setcion-2.png" srcset="../../assets/home/img-main-features-setcion-2@2x.png 2x,
             ../../assets/home/img-main-features-setcion-2@3x.png 3x" class="img_main_features_setcion1">
				</div>
				<div class="description">
					<p class="title" v-html="l10.All_Main_Body_Title3_Subtitle2">

					</p>
					<div class="text">

						<p v-html="l10.All_Main_Body_Title3_Subtitle2_Description1">

						</p>

						<p v-html="l10.All_Main_Body_Title3_Subtitle2_Description2">

						</p>

						<p v-html="l10.All_Main_Body_Title3_Subtitle2_Description3">

						</p>
					</div>
					<router-link to="/features">
						<div class="button">
							<span v-html="l10.All_Main_Body_Title3_Subtitle2_Button1"></span>

						</div>
					</router-link>
				</div>

			</div>

		</div>

	</div>
	<div id="article3" class="container">
		<!-- <img id="awardParts" src="../../assets/home/img-main-award-particle.png"/>
			<img id="awardCharacter" src="../../assets/home/img-main-award-characters.png"/> -->

		<img id="awardCharacter" src="../../assets/home/img-main-award-m.png" />
		<p v-html="l10.All_Main_Body_Title4">

		</p>

	</div>
	<TryTodomathBottom @set-url="setDownloadUrl" @click-cn-androiddownload="handleClickAndroidDownload"></TryTodomathBottom>
	<Footer></Footer>

</div>
</template>
<script>
import Menubar from '../../components/menubar/MobileLayout.vue'
import TryTodomathBottom from '../../components/footer/TryTodomathMobile.vue'
import Footer from '@/components/footer/FooterMobile.vue'
import { isAndroid } from 'mobile-device-detect'
export default {
	name: 'HomeMobileFrame',
	components: {
		Menubar,
		TryTodomathBottom,
		Footer
	},
	data() {
		const text = require('../../text/home/mobile.js').default;
		const l10n = text[this.$store.state.lang] ? text[this.$store.state.lang] : text['en'];
		return {
			l10: l10n,
			downloadUrl: '',
			isAndroid: isAndroid
		}
	},
	methods: {
		setDownloadUrl(msg) {
			this.downloadUrl = msg;
		},
		handleClickAndroidDownload() {
			this.$emit('click-cn-androiddownload')
		}
	}
}
</script>
<style  scoped>
.content {
	width: 100%;
	overflow: hidden;
}

.container {
	margin: 0 auto;
	height: auto;
	min-height: 100px;
	width: 648px;
}

.main-banner {
	background-image: url('../../assets/home/img-main-top-bg-m.png');
	background-repeat: no-repeat;
	background-position: center;
	height: 1627px;
	background-size: 1600px auto;
	padding-top: 166px;
}


.main-banner .title {
	font-size: 64px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.25;
	letter-spacing: -2.5px;
	text-align: center;
	color: #ffffff;

	height: 176px;
	width: 100%;

}

.main-banner .subtitle {
	font-size: 34px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.35;
	letter-spacing: -0.8px;
	color: #ffffff;
	text-align: center;
	margin-top: 20px;
}

.icon_video {
	width: 32px;
	height: 32px;
	object-fit: contain;
	float: left;
}

.main-banner .subject-video {

	font-size: 28px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.71;
	letter-spacing: -0.6px;
	color: #f8ff24;
	width: 202px;
	margin: 0 auto;
	margin-top: 48px;

}

.main-banner .subject-video p {
	float: left;
	line-height: 32px;
	margin-left: 7px;
}

.main-banner #tryBtn {
	width: 100%;
	border: solid 3px #ffffff;
	font-size: 34px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: -1px;
	text-align: center;
	color: #ffffff;
	line-height: 98px;
	border-radius: 8px;
	margin-top: 100px;
}

#appstore {
	margin-top: -4px;
}

.article {
	width: 100%;
	position: relative;
}

#article1 {
	background-color: rgba(255, 0, 0, 0.0);
	margin-top: -180px;
	padding-top: 120px;
}

#article1 .title {
	font-size: 64px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.25;
	letter-spacing: -2.5px;
	text-align: center;
	color: #41403e;
}

#article1 .subtitle {
	font-size: 34px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.35;
	letter-spacing: -1.4px;
	text-align: center;
	color: #41403e;
	margin-top: 20px;

}

#article1 .articles {
	display: flex;
	flex-flow: column;
	justify-content: space-between;

	width: 100%;
	padding: 0 15px;

}

#article1 .articles>div {
	width: 100%;
	display: flex;
	flex-direction: column;
	margin-top: 80px;
}

#article1 .articles>div>img {
	max-width: 130px;
	min-width: 120px;
	align-self: center;
}

#article1 .articles>div>p.description {
	font-size: 28px;
	font-weight: normal;
	font-style: italic;
	font-stretch: normal;
	line-height: 1.36;
	letter-spacing: -1px;
	text-align: center;
	color: #808080;
	margin-top: 20px;
	width: 100%;
	flex-grow: 1;
}

#article1 .articles>div>p.source {
	font-size: 28px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.36;
	letter-spacing: -1px;
	text-align: center;
	color: #bebebe;
	align-self: flex-end;
	width: 100%;
	margin-top: 20px;
}

#article1 #download600Img {
	width: 710px;
	height: 429px;
	background-image: url('../../assets/home/img-main-600-download-m.png');
	background-repeat: no-repeat;
	background-position: bottom;
	z-index: -100;
	background-size: contain;
	margin: 0 auto;
	margin-top: 100px;

}


#article2 {
	position: relative;
	margin-top: -150px;
	background-image: url('../../assets/home/img-main-features-bg-m.png');
	background-repeat: no-repeat;
	background-size: 1600px 3272px;
	background-position: top center;
	padding-bottom: 200px;
}

#article2>div>p:first-of-type {
	position: relative;
	padding-top: 206px;
	width: 100%;
	font-size: 64px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.25;
	letter-spacing: -2.5px;
	text-align: center;
	color: #ffffff;
}

#article2 .descriptions {
	width: 100%;
	color: #000;
	text-align: left;
	margin-top: 80px;
}

#article2 .descriptions>.description .text>p {
	margin-top: 28px;

}

#article2 .descriptions>.description .text p {
	width: 100%;

}

#article2 .descriptions>.description .text p {
	padding-left: 20px;
}

#article2 .descriptions>.description .text p::before {
	content: url("../../assets/home/icon-text-el-wh.svg");
	position: absolute;
	transform: scale(0.8) translateX(-25px) translateY(-3px);
}

#article2 .descriptions:first-of-type>.img {
	width: 100%;
	height: auto;
	object-fit: contain;
	margin-left: -25px;
}

#article2 .descriptions:first-of-type>.img img {
	width: calc(100% + 40px);
	margin-left: -20px;
}

#article2 .descriptions .description:first-child>.description {
	width: 411px;
}

#article2 .descriptions:last-child>.img {
	width: 100%;
	height: auto;
	object-fit: contain;
}

#article2 .descriptions:last-child>.img>img {
	width: 100%;
}

#article2 .descriptions .title {
	font-size: 48px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.17;
	letter-spacing: -2px;
	color: #ffffff;
	margin-top: 60px;
}

#article2 .descriptions .text {
	font-size: 28px;
	font-weight: normal;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.36;
	letter-spacing: -1px;
	color: #ffffff;
	margin-top: 60px;
}

#arcicle2 .bulletedlist {
	width: 8px;
}

#article2 .descriptions .description .button {
	margin-top: 60px;
	width: 100%;
	height: 100px;
	border-radius: 50px;
	border: solid 3px #f8ff24;

	font-size: 28px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 100px;
	letter-spacing: -1.3px;

	text-align: center;
	color: #f8ff24;
}

#article2 .descriptions .description .button::after {
	content: url('../../assets/home/img-btn-arrow.svg');
	position: relative;
	padding-left: 15px;
	display: inline-block;
	transform: scale(1.05);
	top: 2px;

}

#article3 {
	/* margin-top:-100px; */
	height: 1696px;
	position: relative;
}

#article3>img {
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
}

#article3 #awardParts {
	top: 41px;
	width: 1333px;
	height: 798px;
	object-fit: contain;
}

#article3 #awardCharacter {

	width: 880px;
	height: 1596px;
	object-fit: contain;
}

#article3>p {
	font-size: 64px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: 1.25;
	letter-spacing: -3px;
	text-align: center;
	color: #41403e;
	position: relative;
	top: 116px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/HomeMobile.vue